import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import { Doughnut, mixins } from 'vue-chartjs';
import { mapState } from 'vuex';
var reactiveData = mixins.reactiveData;


export default {
    extends: Doughnut,
    mixins: [reactiveData],
    computed: mapState({
        doughnutData: function doughnutData(state) {
            return state.dashboard.table.donutData;
        }
    }),
    data: function data() {
        return {
            options: {
                tooltips: {
                    enabled: false
                },
                legend: {
                    enabled: false
                }
            }
        };
    },

    watch: {
        doughnutData: function doughnutData(val) {
            this.chartData = JSON.parse(_JSON$stringify(val));
        }
    },
    mounted: function mounted() {
        this.chartData = JSON.parse(_JSON$stringify(this.doughnutData));
        this.renderChart(this.chartData, this.options);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/dougthnut.js
// module id = ./src/components/dashboard/dougthnut.js
// module chunks = 5